import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="bookmark-featured"
export default class extends Controller {
    toggle(e) {
        const id = e.target.dataset.id
        const isFeatured = e.target.checked
        const csrfToken = document.querySelector("[name='csrf-token']").content

        fetch(`/bookmarks/${id}/featured`, {
            method: "POST",
            cache: "no-cache",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json",
                "X-CSRF-Token": csrfToken
            },
            body: JSON.stringify({ featured: isFeatured })
        }).then(response => {
            if (!response.ok) throw new Error(`Featured update failed: ${response.status}`)
            window.toast(isFeatured ? "Bookmark is now featured on the landing page" : "Bookmark is no longer featured", { kind: "notice" })
        }).catch(() => {
            e.target.checked = !isFeatured
            window.toast("Couldn't update featured state. Please try again.", { kind: "alert" })
        })
    }
}
